<template>
    <div class="header-inner__catalog">
        <div class="header-inner__catalog-button" 
            :class="{'mobile': mobile, 'desktop': !mobile, active: isCatalogActive}"
            @click="$emit('active-catalog')">
            <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#F6F6F6" stroke-width="1.4"/>
                    <rect x="13.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#F6F6F6" stroke-width="1.4"/>
                    <rect x="2.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#F6F6F6" stroke-width="1.4"/>
                    <rect x="13.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#F6F6F6" stroke-width="1.4"/>
                </svg>
            </span>
            <span>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99982 9.14694C6.85346 9.14694 6.70712 9.09105 6.59553 8.97952L3.08404 5.46799C2.86066 5.24462 2.86066 4.88245 3.08404 4.65916C3.30732 4.43588 3.66942 4.43588 3.89281 4.65916L6.99982 7.76636L10.1069 4.65927C10.3302 4.43599 10.6923 4.43599 10.9156 4.65927C11.139 4.88256 11.139 5.24473 10.9156 5.4681L7.40412 8.97963C7.29248 9.09118 7.14613 9.14694 6.99982 9.14694Z" fill="#F6F6F6"/>
                </svg>
            </span>
        </div>
    </div>

    <transition name="fade-info">
        <div class="category" v-if="isCatalogActive" :class="{ active: isCatalogActive}">
            <div class="category-wrap">
                <div class="category-wrap__row"  v-for="(m, key) in categories.list" :key="key">
                    <h4 class="category-title">
                        {{ m.label }}
                    </h4>
                    <div class="category-item">
                        <a class="category-link"
                            :class="`link-${m2.index}`"
                            v-for="(m2, key2) in m.items" :key="key2"
                            :href="m2.url">
                            <div class="category-info">
                                <p class="category-info__title">{{ m2.label }}</p>
                                <p class="category-info__counter">{{ $t("{count} products", { count: m2.count_products }) }}</p>
                            </div>
                            <div class="category-img__wrap">
                                <div class="category-img__mask">
                                    <picture class="img-responsive active">
                                        <source type="image/webp" srcset="/img/header/category/mask-active.webp 1x, /img/header/category/mask-active@2x.webp 2x, /img/header/category/mask-active@3x.webp 3x">
                                        <source type="image/png" srcset="/img/header/category/mask-active.png 1x, /img/header/category/mask-active@2x.png 2x, /img/header/category/mask-active@3x.png 3x">
                                        <img class="" src="/img/header/category/mask-active.png" alt="mask">
                                    </picture>
                                    <picture class="img-responsive default">
                                        <source type="image/webp" :srcset="`/img/header/category/mask-link-${m2.index}.webp 1x, /img/header/category/mask-link-${m2.index}@2x.webp 2x, /img/header/category/mask-link-${m2.index}@3x.webp 3x`">
                                        <source type="image/png" :srcset="`/img/header/category/mask-link-${m2.index}.png 1x, /img/header/category/mask-link-${m2.index}@2x.png 2x, /img/header/category/mask-link-${m2.index}@3x.png 3x`">
                                        <img :src="`/img/header/category/mask-link-${m2.index}.png`" :alt="m2.label">
                                    </picture>
                                </div>
                                <div class="category-img__picture">
                                    <picture class="img-responsive active">
                                        <source type="image/webp" :srcset="`/img/header/category/link-${m2.index}.webp 1x, /img/header/category/link-${m2.index}@2x.webp 2x, /img/header/category/link-${m2.index}@3x.webp 3x`">
                                        <source type="image/png" :srcset="`/img/header/category/link-${m2.index}.png 1x, /img/header/category/link-${m2.index}@2x.png 2x, /img/header/category/link-${m2.index}@3x.png 3x`">
                                        <img :src="`/img/header/category/link-${m2.index}.png`" :alt="m2.label">
                                    </picture>
                                    <picture class="img-responsive default">
                                        <source type="image/webp" :srcset="`/img/header/category/link-${m2.index}-active.webp 1x, /img/header/category/link-${m2.index}-active@2x.webp 2x, /img/header/category/link-${m2.index}-active@3x.webp 3x`">
                                        <source type="image/png" :srcset="`/img/header/category/link-${m2.index}-active.png 1x, /img/header/category/link-${m2.index}-active@2x.png 2x, /img/header/category/link-${m2.index}-active@3x.png 3x`">
                                        <img :src="`/img/header/category/link-${m2.index}-active.png`" :alt="m2.label">
                                    </picture>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <a :href="categories.link" class="category__all">
                {{ $t("See all Products") }}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                    d="M15.9804 11.6902C15.9804 11.9411 15.8846 12.192 15.6934 12.3833L9.67365 18.403C9.29072 18.7859 8.66986 18.7859 8.28708 18.403C7.90431 18.0202 7.90431 17.3995 8.28708 17.0165L13.6137 11.6902L8.28727 6.36387C7.90449 5.98094 7.90449 5.36027 8.28727 4.97752C8.67004 4.59441 9.2909 4.59441 9.67383 4.97752L15.6936 10.9971C15.8848 11.1885 15.9804 11.4394 15.9804 11.6902Z"
                    fill="currentColor" />
                </svg>
            </a>
        </div>
    </transition>
</template>
  
  <script>
  export default {
    name: 'HeaderCatalog',
    emits: ['active-catalog'],
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        categories: {
            type: Object,
            default: () => {},
        },
        isGuest: {
            type: Boolean,
            default: false,
        },
        isCatalogActive: {
            type: Boolean,
            default: false,
        }
    },
  };
  </script>

<style lang="scss" scoped>
    .fade-info-enter-active,
    .fade-info-leave-active {
        transition: opacity 0.4s ease;
    }

    .fade-info-enter-from,
    .fade-info-leave-to {
        opacity: 0;
    }

    .fade-info-enter-to,
    .fade-info-leave-from {
        opacity: 1;
    }

</style>
